import { auth, googleAuthProvider, database } from '../../firebase';
import * as logger from '../../helpers/logger'

export enum AUTH_ACTION_TYPES {
  ATTEMPTING_LOGIN = '@DONACO/ATTEMPTING_LOGIN',
  LOGIN_FAIL = '@DONACO/LOGIN_FAIL',
  SIGN_IN = '@DONACO/SIGN_IN',
  SIGN_OUT = '@DONACO/SIGN_OUT',
  SET_AS_ADMIN = '@DONACO/SET_AS_ADMIN',
  UPDATE_USER = '@DONACO/UPDATE_USER'
}

export const signInGoogle = () => {
  return (dispatch) => {
    dispatch({ type: AUTH_ACTION_TYPES.ATTEMPTING_LOGIN });
    auth.signInWithPopup(googleAuthProvider);
  };
};

export const signInEmailPassword = (email: string, password: string) => {
  return (dispatch) => {
    dispatch({ type: AUTH_ACTION_TYPES.ATTEMPTING_LOGIN });
    auth.signInWithEmailAndPassword(email, password).catch((error) => {
      dispatch({ type: AUTH_ACTION_TYPES.LOGIN_FAIL });
    });
  };
};

export const signOut = () => {
  return (dispatch) => {
    dispatch({ type: AUTH_ACTION_TYPES.ATTEMPTING_LOGIN });
    auth.signOut();
  };
};

export const updateUser = (user) => ({type: AUTH_ACTION_TYPES.UPDATE_USER, user})